export const RECHARTS_COLORS = {
  TEXT_PRIMARY: getComputedStyle(document.documentElement)
    .getPropertyValue('--text-primary')
    .trim(),
  BORDER_PRIMARY: getComputedStyle(document.documentElement)
    .getPropertyValue('--border-primary')
    .trim(),
  BORDER_SECONDARY: getComputedStyle(document.documentElement)
    .getPropertyValue('--border-secondary')
    .trim(),
};

export const CHART_ITEM_LENGTH = 80;
